import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, Button, notification } from 'antd';
import './RoomSetupModal.css';

const { Text } = Typography;
const { Search } = Input;

@inject('RoomSetupStore')
@observer
class RoomSetupModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    // ON Search

    roomOnSearch = () => {
        this.props.RoomSetupStore.setRoomSearchValue('');
        this.props.RoomSetupStore.searchRoom();
        this.props.RoomSetupStore.setShowRoomSearchModal(true);
    }

    roomTypeOnSearch = () => {
        this.props.RoomSetupStore.setRoomTypeSearchValue('');
        this.props.RoomSetupStore.searchRoomType();
        this.props.RoomSetupStore.setShowRoomTypeSearchModal(true);
    }

    // ON CLICK

    createOrUpdateRoomSetupOnClick = () => {
        const { roomAndRoomTypeId } = this.props.RoomSetupStore;
        if (roomAndRoomTypeId === 0) {
            this.props.RoomSetupStore.createRoomSetup().then(response => {
                if (!response.isError) {
                    notification['success']({
                        message: 'Success',
                        description: 'Room setup has been successfully created.',
                        duration: 3
                    });
                    this.props.RoomSetupStore.initRoomSetup();
                } else {
                    notification['error']({
                        message: 'Error',
                        description: response.errorMessage,
                        duration: 3
                    });
                }
            });
        } else {
            this.props.RoomSetupStore.updateRoomSetup().then(response => {
                if (!response.isError) {
                    notification['success']({
                        message: 'Success',
                        description: 'Room setup has been successfully updated.',
                        duration: 3
                    });
                    this.props.RoomSetupStore.initRoomSetup();
                } else {
                    notification['error']({
                        message: 'Error',
                        description: response.errorMessage,
                        duration: 3
                    });
                }
            });
        }
    }

    render() {
        const {
            roomName,
            roomTypeName,
            roomSetupTextButton,
            roomSetupModalLoading
        } = this.props.RoomSetupStore;

        let addOrUpdateRoomSetupDisable = false;
        if (roomName === '' || roomTypeName === '') {
            addOrUpdateRoomSetupDisable = true;
        }

        return (
            <Spin spinning={roomSetupModalLoading}>
                <Row className='roomsetupmodal-row-container'>
                    <Col span={24} className='roomsetupmodal-col'>
                        <Row>
                            <Col span={8} className='roomsetupmodal-col-label'>
                                <Text className='roomsetupmodal-text-label'>Room<Text className='roomsetupmodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='roomsetupmodal-col-input'>
                                <Search
                                    placeholder='Search room'
                                    value={roomName}
                                    onSearch={this.roomOnSearch}
                                    enterButton
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='roomsetupmodal-col'>
                        <Row>
                            <Col span={8} className='roomsetupmodal-col-label'>
                                <Text className='roomsetupmodal-text-label'>Room Type<Text className='roomsetupmodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='roomsetupmodal-col-input'>
                                <Search
                                    placeholder='Search room type'
                                    value={roomTypeName}
                                    onSearch={this.roomTypeOnSearch}
                                    enterButton
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='roomsetupmodal-col-button'>
                        <Button disabled={addOrUpdateRoomSetupDisable} type='primary' className='roomsetupmodal-button' onClick={this.createOrUpdateRoomSetupOnClick}>{roomSetupTextButton}</Button>
                    </Col>
                </Row>
            </Spin >
        )
    }
}

export default RoomSetupModalPage;